/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddConsumptionDto,
  CancelSessionDto,
  CompleteSessionDto,
  ConsumptionSuggestionResponse,
  CreateSessionDto,
  PatientTimelineResponse,
  RecordedSessionResponse,
  SessionListResponse,
  SessionResponse,
  SessionsConsumptionSuggestionsParams,
  SessionsListParams,
  SessionsPatientTimelineParams,
  UpdateSessionDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * بدون دسترسی session.view_all فقط جلسات خودِ کاربر برگردانده می‌شود. مبالغ بهای تمام‌شده و سود، بدون دسترسی‌های inventory.view_costs و finance.view_profit به‌صورت null برمی‌گردند.
 * @summary فهرست جلسات درمان
 */
export const sessionsList = (
    params?: SessionsListParams,
 signal?: AbortSignal
) => {


      return apiClient<SessionListResponse>(
      {url: `/api/v1/sessions`, method: 'GET',
        params, signal
    },
      );
    }




export const getSessionsListQueryKey = (params?: SessionsListParams,) => {
    return [
    `/api/v1/sessions`, ...(params ? [params] : [])
    ] as const;
    }


export const getSessionsListQueryOptions = <TData = Awaited<ReturnType<typeof sessionsList>>, TError = void>(params?: SessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionsList>>> = ({ signal }) => sessionsList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SessionsListQueryResult = NonNullable<Awaited<ReturnType<typeof sessionsList>>>
export type SessionsListQueryError = void


export function useSessionsList<TData = Awaited<ReturnType<typeof sessionsList>>, TError = void>(
 params: undefined |  SessionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sessionsList>>,
          TError,
          Awaited<ReturnType<typeof sessionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSessionsList<TData = Awaited<ReturnType<typeof sessionsList>>, TError = void>(
 params?: SessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sessionsList>>,
          TError,
          Awaited<ReturnType<typeof sessionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSessionsList<TData = Awaited<ReturnType<typeof sessionsList>>, TError = void>(
 params?: SessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست جلسات درمان
 */

export function useSessionsList<TData = Awaited<ReturnType<typeof sessionsList>>, TError = void>(
 params?: SessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSessionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * همهٔ این کارها در **یک تراکنش** انجام می‌شود: ثبت جلسه، کسر مواد از بچ‌های انتخاب‌شده با ثبت بهای واحد در همان لحظه، ثبت گردش انبار، محاسبهٔ بهای تمام‌شده و سود، کسر یک جلسه از پکیج (اگر paymentMethod=PACKAGE)، اعطای امتیاز وفاداری، و ساخت زنجیرهٔ یادآوری پیگیری از قواعد خدمت. اگر هر مرحله شکست بخورد، هیچ‌کدام ثبت نمی‌شود.
 *
 * اگر خدمت رضایت‌نامه لازم داشته باشد و رضایت‌نامهٔ امضاشدهٔ معتبری وجود نداشته باشد، پاسخ 422 با کد TREATMENT_CONSENT_REQUIRED است و هیچ چیزی نوشته نمی‌شود.
 * @summary ثبت جلسهٔ درمان
 */
export const sessionsRecord = (
    createSessionDto: CreateSessionDto,
 signal?: AbortSignal
) => {


      return apiClient<RecordedSessionResponse>(
      {url: `/api/v1/sessions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSessionDto, signal
    },
      );
    }




export const getSessionsRecordMutationKey = () => ['sessionsRecord'] as const;

export const getSessionsRecordMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsRecord>>, TError,SessionsRecordMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionsRecord>>, TError,SessionsRecordMutationVariables, TContext> => {

const mutationKey = getSessionsRecordMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionsRecord>>, SessionsRecordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sessionsRecord(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SessionsRecordMutationResult = NonNullable<Awaited<ReturnType<typeof sessionsRecord>>>
    export type SessionsRecordMutationBody = CreateSessionDto
    export type SessionsRecordMutationError = void
    export type SessionsRecordMutationVariables = {data: CreateSessionDto}

    /**
 * @summary ثبت جلسهٔ درمان
 */
export const useSessionsRecord = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsRecord>>, TError,SessionsRecordMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sessionsRecord>>,
        TError,
        SessionsRecordMutationVariables,
        TContext
      > => {
      return useMutation(getSessionsRecordMutationOptions(options), queryClient);
    }
    /**
 * جلسات، نوبت‌ها، یادآوری‌های پیگیری و پرداخت‌های یک بیمار، در یک جریان زمانی مرتب‌شده از جدید به قدیم. یادآوری‌ها با تاریخ **سررسید** در تایم‌لاین می‌نشینند، نه تاریخ ساخته‌شدنشان.
 * @summary تایم‌لاین پروندهٔ بیمار
 */
export const sessionsPatientTimeline = (
    params: SessionsPatientTimelineParams,
 signal?: AbortSignal
) => {


      return apiClient<PatientTimelineResponse>(
      {url: `/api/v1/sessions/timeline`, method: 'GET',
        params, signal
    },
      );
    }




export const getSessionsPatientTimelineQueryKey = (params?: SessionsPatientTimelineParams,) => {
    return [
    `/api/v1/sessions/timeline`, ...(params ? [params] : [])
    ] as const;
    }


export const getSessionsPatientTimelineQueryOptions = <TData = Awaited<ReturnType<typeof sessionsPatientTimeline>>, TError = void>(params: SessionsPatientTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsPatientTimeline>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionsPatientTimelineQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionsPatientTimeline>>> = ({ signal }) => sessionsPatientTimeline(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionsPatientTimeline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SessionsPatientTimelineQueryResult = NonNullable<Awaited<ReturnType<typeof sessionsPatientTimeline>>>
export type SessionsPatientTimelineQueryError = void


export function useSessionsPatientTimeline<TData = Awaited<ReturnType<typeof sessionsPatientTimeline>>, TError = void>(
 params: SessionsPatientTimelineParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsPatientTimeline>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sessionsPatientTimeline>>,
          TError,
          Awaited<ReturnType<typeof sessionsPatientTimeline>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSessionsPatientTimeline<TData = Awaited<ReturnType<typeof sessionsPatientTimeline>>, TError = void>(
 params: SessionsPatientTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsPatientTimeline>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sessionsPatientTimeline>>,
          TError,
          Awaited<ReturnType<typeof sessionsPatientTimeline>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSessionsPatientTimeline<TData = Awaited<ReturnType<typeof sessionsPatientTimeline>>, TError = void>(
 params: SessionsPatientTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsPatientTimeline>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary تایم‌لاین پروندهٔ بیمار
 */

export function useSessionsPatientTimeline<TData = Awaited<ReturnType<typeof sessionsPatientTimeline>>, TError = void>(
 params: SessionsPatientTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsPatientTimeline>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSessionsPatientTimelineQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * فرم مواد مصرفی را پیش‌پر می‌کند: مصرف پیش‌فرض خدمت، و برای هر ماده بچی که زودتر از همه منقضی می‌شود و مقدار لازم را دارد. **هیچ چیزی رزرو نمی‌شود** — پیشنهاد است، نه قفل موجودی. اگر هیچ بچی به‌تنهایی مقدار لازم را نداشته باشد insufficient=true برمی‌گردد و availableMilli می‌گوید کل موجودی چقدر است.
 * @summary پیشنهاد مواد مصرفی و بچ (FEFO)
 */
export const sessionsConsumptionSuggestions = (
    params?: SessionsConsumptionSuggestionsParams,
 signal?: AbortSignal
) => {


      return apiClient<ConsumptionSuggestionResponse>(
      {url: `/api/v1/sessions/consumption-suggestions`, method: 'GET',
        params, signal
    },
      );
    }




export const getSessionsConsumptionSuggestionsQueryKey = (params?: SessionsConsumptionSuggestionsParams,) => {
    return [
    `/api/v1/sessions/consumption-suggestions`, ...(params ? [params] : [])
    ] as const;
    }


export const getSessionsConsumptionSuggestionsQueryOptions = <TData = Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>, TError = void>(params?: SessionsConsumptionSuggestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionsConsumptionSuggestionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>> = ({ signal }) => sessionsConsumptionSuggestions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SessionsConsumptionSuggestionsQueryResult = NonNullable<Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>>
export type SessionsConsumptionSuggestionsQueryError = void


export function useSessionsConsumptionSuggestions<TData = Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>, TError = void>(
 params: undefined |  SessionsConsumptionSuggestionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>,
          TError,
          Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSessionsConsumptionSuggestions<TData = Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>, TError = void>(
 params?: SessionsConsumptionSuggestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>,
          TError,
          Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSessionsConsumptionSuggestions<TData = Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>, TError = void>(
 params?: SessionsConsumptionSuggestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary پیشنهاد مواد مصرفی و بچ (FEFO)
 */

export function useSessionsConsumptionSuggestions<TData = Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>, TError = void>(
 params?: SessionsConsumptionSuggestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsConsumptionSuggestions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSessionsConsumptionSuggestionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary جزئیات یک جلسهٔ درمان
 */
export const sessionsGetById = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<SessionResponse>(
      {url: `/api/v1/sessions/${id}`, method: 'GET', signal
    },
      );
    }




export const getSessionsGetByIdQueryKey = (id: string,) => {
    return [
    `/api/v1/sessions/${id}`
    ] as const;
    }


export const getSessionsGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof sessionsGetById>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsGetById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionsGetByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionsGetById>>> = ({ signal }) => sessionsGetById(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionsGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SessionsGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof sessionsGetById>>>
export type SessionsGetByIdQueryError = void


export function useSessionsGetById<TData = Awaited<ReturnType<typeof sessionsGetById>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsGetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sessionsGetById>>,
          TError,
          Awaited<ReturnType<typeof sessionsGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSessionsGetById<TData = Awaited<ReturnType<typeof sessionsGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsGetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sessionsGetById>>,
          TError,
          Awaited<ReturnType<typeof sessionsGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSessionsGetById<TData = Awaited<ReturnType<typeof sessionsGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary جزئیات یک جلسهٔ درمان
 */

export function useSessionsGetById<TData = Awaited<ReturnType<typeof sessionsGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionsGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSessionsGetByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * مبلغ، پزشک، زمان و یادداشت. **مواد مصرفی از این مسیر تغییر نمی‌کند** — افزودن یا حذف ماده موجودی را جابه‌جا می‌کند و مسیر جداگانهٔ خودش را دارد تا هر جابه‌جایی یک گردش انبار ثبت‌شده داشته باشد.
 * @summary ویرایش جلسه
 */
export const sessionsUpdate = (
    id: string,
    updateSessionDto: UpdateSessionDto,
 signal?: AbortSignal
) => {


      return apiClient<SessionResponse>(
      {url: `/api/v1/sessions/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSessionDto, signal
    },
      );
    }




export const getSessionsUpdateMutationKey = () => ['sessionsUpdate'] as const;

export const getSessionsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsUpdate>>, TError,SessionsUpdateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionsUpdate>>, TError,SessionsUpdateMutationVariables, TContext> => {

const mutationKey = getSessionsUpdateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionsUpdate>>, SessionsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  sessionsUpdate(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SessionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof sessionsUpdate>>>
    export type SessionsUpdateMutationBody = UpdateSessionDto
    export type SessionsUpdateMutationError = void
    export type SessionsUpdateMutationVariables = {id: string;data: UpdateSessionDto}

    /**
 * @summary ویرایش جلسه
 */
export const useSessionsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsUpdate>>, TError,SessionsUpdateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sessionsUpdate>>,
        TError,
        SessionsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getSessionsUpdateMutationOptions(options), queryClient);
    }
    /**
 * حذف نرم است. جلسه‌ای که مواد مصرفی ثبت‌شده دارد ابتدا باید لغو شود تا موجودی برگردد؛ در غیر این صورت پاسخ 409 است.
 * @summary حذف جلسه (سطل بازیافت)
 */
export const sessionsRemove = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/sessions/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getSessionsRemoveMutationKey = () => ['sessionsRemove'] as const;

export const getSessionsRemoveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsRemove>>, TError,SessionsRemoveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionsRemove>>, TError,SessionsRemoveMutationVariables, TContext> => {

const mutationKey = getSessionsRemoveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionsRemove>>, SessionsRemoveMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  sessionsRemove(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SessionsRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof sessionsRemove>>>

    export type SessionsRemoveMutationError = void
    export type SessionsRemoveMutationVariables = {id: string}

    /**
 * @summary حذف جلسه (سطل بازیافت)
 */
export const useSessionsRemove = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsRemove>>, TError,SessionsRemoveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sessionsRemove>>,
        TError,
        SessionsRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getSessionsRemoveMutationOptions(options), queryClient);
    }
    /**
 * جلسهٔ PLANNED را به COMPLETED می‌برد و همان تراکنش کامل ثبت را اجرا می‌کند: کسر مواد، پکیج، امتیاز و ساخت یادآوری‌ها. **دروازهٔ رضایت‌نامه اینجاست**: بدون رضایت‌نامهٔ امضاشدهٔ معتبر، پاسخ 422 با کد TREATMENT_CONSENT_REQUIRED است و وضعیت جلسه تغییر نمی‌کند.
 * @summary نهایی کردن جلسهٔ برنامه‌ریزی‌شده
 */
export const sessionsComplete = (
    id: string,
    completeSessionDto: CompleteSessionDto,
 signal?: AbortSignal
) => {


      return apiClient<RecordedSessionResponse>(
      {url: `/api/v1/sessions/${id}/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeSessionDto, signal
    },
      );
    }




export const getSessionsCompleteMutationKey = () => ['sessionsComplete'] as const;

export const getSessionsCompleteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsComplete>>, TError,SessionsCompleteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionsComplete>>, TError,SessionsCompleteMutationVariables, TContext> => {

const mutationKey = getSessionsCompleteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionsComplete>>, SessionsCompleteMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  sessionsComplete(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SessionsCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof sessionsComplete>>>
    export type SessionsCompleteMutationBody = CompleteSessionDto
    export type SessionsCompleteMutationError = void
    export type SessionsCompleteMutationVariables = {id: string;data: CompleteSessionDto}

    /**
 * @summary نهایی کردن جلسهٔ برنامه‌ریزی‌شده
 */
export const useSessionsComplete = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsComplete>>, TError,SessionsCompleteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sessionsComplete>>,
        TError,
        SessionsCompleteMutationVariables,
        TContext
      > => {
      return useMutation(getSessionsCompleteMutationOptions(options), queryClient);
    }
    /**
 * مواد مصرفی به موجودی برمی‌گردد (با ثبت گردش انبار از نوع RETURN، بدون دست‌زدن به ردیف مصرف قبلی)، جلسهٔ کسرشده به پکیج برمی‌گردد، امتیاز وفاداری با یک ردیف اصلاحی پس گرفته می‌شود و یادآوری‌های پیگیری **لغو** می‌شوند (نه حذف — پرونده باید نشان دهد که پیگیری برنامه‌ریزی شده بود و چرا انجام نمی‌شود).
 * @summary لغو جلسه
 */
export const sessionsCancel = (
    id: string,
    cancelSessionDto: CancelSessionDto,
 signal?: AbortSignal
) => {


      return apiClient<SessionResponse>(
      {url: `/api/v1/sessions/${id}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelSessionDto, signal
    },
      );
    }




export const getSessionsCancelMutationKey = () => ['sessionsCancel'] as const;

export const getSessionsCancelMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsCancel>>, TError,SessionsCancelMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionsCancel>>, TError,SessionsCancelMutationVariables, TContext> => {

const mutationKey = getSessionsCancelMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionsCancel>>, SessionsCancelMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  sessionsCancel(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SessionsCancelMutationResult = NonNullable<Awaited<ReturnType<typeof sessionsCancel>>>
    export type SessionsCancelMutationBody = CancelSessionDto
    export type SessionsCancelMutationError = void
    export type SessionsCancelMutationVariables = {id: string;data: CancelSessionDto}

    /**
 * @summary لغو جلسه
 */
export const useSessionsCancel = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsCancel>>, TError,SessionsCancelMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sessionsCancel>>,
        TError,
        SessionsCancelMutationVariables,
        TContext
      > => {
      return useMutation(getSessionsCancelMutationOptions(options), queryClient);
    }
    /**
 * برای وقتی که حین جلسه ویال دومی باز می‌شود. اگر lotId نفرستید، بچ با نزدیک‌ترین انقضا انتخاب می‌شود؛ اگر بچ دیگری بفرستید، overrideReason اجباری است. بهای تمام‌شده و سود جلسه دوباره محاسبه می‌شود.
 * @summary افزودن مادهٔ مصرفی به جلسه
 */
export const sessionsAddConsumptions = (
    id: string,
    addConsumptionDto: AddConsumptionDto,
 signal?: AbortSignal
) => {


      return apiClient<SessionResponse>(
      {url: `/api/v1/sessions/${id}/consumptions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addConsumptionDto, signal
    },
      );
    }




export const getSessionsAddConsumptionsMutationKey = () => ['sessionsAddConsumptions'] as const;

export const getSessionsAddConsumptionsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsAddConsumptions>>, TError,SessionsAddConsumptionsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionsAddConsumptions>>, TError,SessionsAddConsumptionsMutationVariables, TContext> => {

const mutationKey = getSessionsAddConsumptionsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionsAddConsumptions>>, SessionsAddConsumptionsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  sessionsAddConsumptions(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SessionsAddConsumptionsMutationResult = NonNullable<Awaited<ReturnType<typeof sessionsAddConsumptions>>>
    export type SessionsAddConsumptionsMutationBody = AddConsumptionDto
    export type SessionsAddConsumptionsMutationError = void
    export type SessionsAddConsumptionsMutationVariables = {id: string;data: AddConsumptionDto}

    /**
 * @summary افزودن مادهٔ مصرفی به جلسه
 */
export const useSessionsAddConsumptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsAddConsumptions>>, TError,SessionsAddConsumptionsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sessionsAddConsumptions>>,
        TError,
        SessionsAddConsumptionsMutationVariables,
        TContext
      > => {
      return useMutation(getSessionsAddConsumptionsMutationOptions(options), queryClient);
    }
    /**
 * ردیف مصرف حذف می‌شود تا بهای تمام‌شدهٔ جلسه درست بماند، و یک گردش انبار از نوع RETURN ثبت می‌شود تا دفتر انبار هر دو حرکت را نگه دارد.
 * @summary حذف یک خط مصرف و بازگرداندن آن به موجودی
 */
export const sessionsRemoveConsumption = (
    id: string,
    consumptionId: string,
 signal?: AbortSignal
) => {


      return apiClient<SessionResponse>(
      {url: `/api/v1/sessions/${id}/consumptions/${consumptionId}`, method: 'DELETE', signal
    },
      );
    }




export const getSessionsRemoveConsumptionMutationKey = () => ['sessionsRemoveConsumption'] as const;

export const getSessionsRemoveConsumptionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsRemoveConsumption>>, TError,SessionsRemoveConsumptionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionsRemoveConsumption>>, TError,SessionsRemoveConsumptionMutationVariables, TContext> => {

const mutationKey = getSessionsRemoveConsumptionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionsRemoveConsumption>>, SessionsRemoveConsumptionMutationVariables> = (props) => {
          const {id,consumptionId} = props ?? {};

          return  sessionsRemoveConsumption(id,consumptionId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SessionsRemoveConsumptionMutationResult = NonNullable<Awaited<ReturnType<typeof sessionsRemoveConsumption>>>

    export type SessionsRemoveConsumptionMutationError = void
    export type SessionsRemoveConsumptionMutationVariables = {id: string;consumptionId: string}

    /**
 * @summary حذف یک خط مصرف و بازگرداندن آن به موجودی
 */
export const useSessionsRemoveConsumption = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionsRemoveConsumption>>, TError,SessionsRemoveConsumptionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sessionsRemoveConsumption>>,
        TError,
        SessionsRemoveConsumptionMutationVariables,
        TContext
      > => {
      return useMutation(getSessionsRemoveConsumptionMutationOptions(options), queryClient);
    }
